document.addEventListener("DOMContentLoaded", function() {
  const mobileHamburger = document.querySelector(".mobile-hamburger");
  const mobileNav = document.querySelector(".mobile-nav");

  mobileHamburger.addEventListener("click", function() {
    if (mobileNav.classList.contains("active")) {
        mobileNav.classList.remove("active");

        mobileNav.style.height = "0";
    }
    else {
        mobileNav.classList.add("active");

        const mobileNavLinks = mobileNav.querySelectorAll("a");
        let height = mobileNavLinks.length * 22 + (mobileNavLinks.length - 1) * 15;

        const mobileDropdownMenu = mobileNav.querySelector(".dropdown-menu");
        if (mobileDropdownMenu.classList.contains("active")) {
          height += 116;
        }
        
        mobileNav.style.height = `${height}px`;
    }
  });

  /* Mobile Dropdown */
  const mobileTitleContainer = mobileNav.querySelector(".title-container");
  const mobileDropdownMenu = mobileNav.querySelector(".dropdown-menu");
  mobileTitleContainer.addEventListener("click", function() {
    if (mobileDropdownMenu.classList.contains("active")) {
      mobileDropdownMenu.classList.remove("active");

      const mobileNavLinks = mobileNav.querySelectorAll("a");
      const height = mobileNavLinks.length * 22 + (mobileNavLinks.length - 1) * 15;
      mobileNav.style.height = `${height}px`;
    }
    else {
      mobileDropdownMenu.classList.add("active");

      const mobileNavLinks = mobileNav.querySelectorAll("a");
      const height = mobileNavLinks.length * 22 + (mobileNavLinks.length - 1) * 15 + 116;
      mobileNav.style.height = `${height}px`;
    }
  });

  /* End Mobile Dropdown */
});